module.exports = __webpack_public_path__ + "da2a97f76ef858b903f0aabd63fe799c.png";